import styled from 'styled-components';

import { IImageSource, progressiveBackground } from '@r1-frontend/ui-react/components/helpers/image';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4, H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { IndentContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

type TCategoryProps = {
    title: string,
    image: IImageSource,
    width: number,

    selected?: boolean,
    onClick?: () => void,

    className?: string,
}

const Category = ({ title, className, onClick }: TCategoryProps) => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    return (
        <RounderContainer
            className={className}
            $radius={24}
            onClick={onClick}
        >
            <IndentContainer $united={[24]}>
                {isTablet
                    ? <H5 $withIndent={false}>{title}</H5>
                    : <H4 $smaller $withIndent={false}>{title}</H4>
                }
            </IndentContainer>
        </RounderContainer>
    );
};

export default styled(Category)<TCategoryProps>`
    width: ${p => p.width}px;
    height: 220px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 180px;
    }

    background-color: ${COLORS.BgSurface};
    background-size: cover;
    background-position: center;

    text-align: center;
    transition: 0.3s;

    &:hover {
        background-color: ${COLORS.ButtonSecondary};

        h4, h5 {
            color: ${COLORS.ButtonAccent};
        }
    }

    ${p => p.selected && `
        h4, h5 {
            color: ${COLORS.ButtonAccent};
        }
    `}

    ${p => progressiveBackground(p.image)};

    ${IndentContainer} {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
`;
